import React, { useEffect } from "react";
import { SITE_NAME, CONTACT_URL, CONTACT_LABEL, SOCIALS } from "../constants/siteConfig";

export default function ContactPage({ onClose, onOpenPrivacy }) {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div className="legal-backdrop" onClick={onClose}>
      <article className="legal-modal" role="dialog" aria-label="Contact us" onClick={(e) => e.stopPropagation()}>
        <header>
          <h2>Contact us</h2>
          <button className="slide-panel-close" onClick={onClose} aria-label="Close">×</button>
        </header>

        <div className="legal-body">
          <p>
            {SITE_NAME} doesn't have a contact email. The best way to reach us is to open an issue on{" "}
            <a href={CONTACT_URL} target="_blank" rel="noopener noreferrer">{CONTACT_LABEL}</a>.
            You'll need a free GitHub account.
          </p>

          <p>
            <a className="panel-primary" href={CONTACT_URL} target="_blank" rel="noopener noreferrer" style={{ display: "inline-block", textDecoration: "none" }}>
              Open GitHub issues ↗
            </a>
          </p>

          <h3>Find me on social media</h3>
          <p>You can also reach me on these. Replies may be slower than GitHub, and these are public too.</p>
          <ul className="social-links">
            {SOCIALS.map((s) => (
              <li key={s.key}>
                <a className="social-link" href={s.url} target="_blank" rel="noopener noreferrer">
                  <span className="social-link-name">{s.label}</span>
                  <span className="social-link-handle">{s.handle} ↗</span>
                </a>
              </li>
            ))}
          </ul>

          <p>
            <strong>Issues on GitHub are public.</strong> Please don't post private personal information, and see the{" "}
            <button type="button" className="panel-link" onClick={onOpenPrivacy}>Privacy Policy</button> for how we handle data.
          </p>

          <h3>What to contact us about</h3>
          <ul>
            <li>
              <strong>Image removal or credit corrections.</strong> If you took a photo, or own the rights to one, and
              want it removed or credited differently, include the wreck's name or <strong>boat ID</strong>, the image
              URL, and what you'd like changed. You don't need an account here to make this request.
            </li>
            <li>
              <strong>Privacy requests.</strong> Access, correction or deletion of your information. You can also
              delete your own account from <em>Settings</em> when you're logged in.
            </li>
            <li>
              <strong>Bugs and feature ideas.</strong> Tell us what you did, what you expected, and what happened.
            </li>
            <li>
              <strong>Reporting a problem entry.</strong> Log in, open the wreck and press <em>⚑ Report</em>. It goes
              straight to the admins, and you'll get a notification when they've looked at it.
            </li>
            <li>
              <strong>Reporting a problem user.</strong> Include the username and what's wrong.
            </li>
          </ul>

          <h3>Fixing a wreck's details</h3>
          <p>
            For wrong dates, names, locations or descriptions, you don't need to contact us. Log in, open the wreck,
            and use <em>✎ Suggest edit</em>. An admin will review it.
          </p>
        </div>

        <footer>
          <button className="panel-primary" onClick={onClose}>Close</button>
        </footer>
      </article>
    </div>
  );
}
